import managerApi from "../../api/manager";
import moment from "moment";
import profileApi from "../../api/profile";

// initial state
const state = {};

const getters = {};

const actions = {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      managerApi.getAllManagers(
        managers => {
          resolve(managers);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getManager({ commit }, managerId) {
    return new Promise((resolve, reject) => {
      if (typeof managerId === "object") {
        managerId = managerId.id;
      }
      managerApi.getManager(
        managerId,
        manager => {
          resolve(manager);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateOwnProfile({ commit }, params) {
    return new Promise((resolve, reject) => {
      profileApi.managerUpdate(
        params,
        profile => {
          resolve(profile);
        },
        error => {
          console.log("Something broke at the API");
          reject(error);
        }
      );
    });
  },

  createManager({ commit }, payload) {
    return new Promise((resolve, reject) => {
      managerApi.create(
        payload,
        manager => {
          resolve(manager);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  update({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      managerApi.update(
        idFieldData,
        manager => {
          resolve(manager);
        },
        error => {
          console.log("Something broke at the API");
          reject();
        }
      );
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
